
import { Component, Vue, Prop } from 'vue-property-decorator';
import ModalDefaultPopupBodyOrientation from '@/components/ModalDefaultPopupBodyOrientation.vue';
import OrgErrorMessage from '@/components/OrgErrorMessage.vue';

export enum MessageTypeErrorFaceAction {
  None,
  FaceNotFound,
  DifferentDirection,
  Timeout,
  InvalidScreenOrientation,
  CVInvalidFeatureBrightness,
  CVInvalidFeatureSharpness,
  CVInvalidFeatureHighlight,
  CVInvalidFeatureSunglass,
  CVInvalidFeatureStraight,
  CVInvalidFeatureIsGrayscale,
  Unknown
}

interface CautionMessage {
  Title: string;
  Description: string;
}

@Component({
  components: {
    OrgErrorMessage,
    ModalDefaultPopupBodyOrientation
  }
})
export default class Parts extends Vue {
  @Prop({ type: Number, default: MessageTypeErrorFaceAction.Unknown })
  private messageType!: MessageTypeErrorFaceAction;

  @Prop({ type: Boolean, default: false })
  private isManyRetry!: boolean;

  private get isFaceActionErrorOrientation(): boolean {
    if (this.$route.name !== 'face-action-error') return false;
    return this.messageType === MessageTypeErrorFaceAction.InvalidScreenOrientation;
  }

  private get messageHtml(): string {
    switch (this.messageType) {
      case MessageTypeErrorFaceAction.FaceNotFound:
        return this.$i18n.tc('componentsfacetrackerFaceDirectionModal.MessageHtmls.FaceNotFound');

      case MessageTypeErrorFaceAction.DifferentDirection:
        return this.$i18n.tc('componentsfacetrackerFaceDirectionModal.MessageHtmls.DifferentDirection');

      case MessageTypeErrorFaceAction.Timeout:
        return this.$i18n.tc('componentsfacetrackerFaceDirectionModal.MessageHtmls.Timeout');

      case MessageTypeErrorFaceAction.InvalidScreenOrientation:
        return this.$i18n.tc('componentsfacetrackerFaceDirectionModal.MessageHtmls.InvalidScreenOrientation');

      case MessageTypeErrorFaceAction.CVInvalidFeatureBrightness:
        return this.$i18n.tc('componentsfacetrackerFaceDirectionModal.MessageHtmls.CVInvalidFeatureBrightness');

      case MessageTypeErrorFaceAction.CVInvalidFeatureSharpness:
        return this.$i18n.tc('componentsfacetrackerFaceDirectionModal.MessageHtmls.CVInvalidFeatureSharpness');

      case MessageTypeErrorFaceAction.CVInvalidFeatureHighlight:
        return this.$i18n.tc('componentsfacetrackerFaceDirectionModal.MessageHtmls.CVInvalidFeatureHighlight');

      case MessageTypeErrorFaceAction.CVInvalidFeatureSunglass:
        return this.$i18n.tc('componentsfacetrackerFaceDirectionModal.MessageHtmls.CVInvalidFeatureSunglass');

      case MessageTypeErrorFaceAction.CVInvalidFeatureStraight:
        return this.$i18n.tc('componentsfacetrackerFaceDirectionModal.MessageHtmls.CVInvalidFeatureStraight');

      case MessageTypeErrorFaceAction.CVInvalidFeatureIsGrayscale:
        return this.$i18n.tc('componentsfacetrackerFaceDirectionModal.MessageHtmls.CVInvalidFeatureIsGrayscale');

      case MessageTypeErrorFaceAction.None:
        return '';

      case MessageTypeErrorFaceAction.Unknown:
      default:
        return this.$i18n.tc('componentsfacetrackerFaceDirectionModal.MessageHtmls.Unknown');
    }
  }

  private get cautionMessageHtml(): CautionMessage[] {
    switch (this.messageType) {
      case MessageTypeErrorFaceAction.FaceNotFound:
        return this.$t('componentsfacetrackerFaceDirectionModal.CautionMessageHtmls.FaceNotFound') as {
          [key: number]: unknown;
        } as CautionMessage[];

      case MessageTypeErrorFaceAction.DifferentDirection:
        return this.$t('componentsfacetrackerFaceDirectionModal.CautionMessageHtmls.DifferentDirection') as {
          [key: number]: unknown;
        } as CautionMessage[];

      case MessageTypeErrorFaceAction.CVInvalidFeatureBrightness:
        return this.$t('componentsfacetrackerFaceDirectionModal.CautionMessageHtmls.CVInvalidFeatureBrightness') as {
          [key: number]: unknown;
        } as CautionMessage[];

      case MessageTypeErrorFaceAction.CVInvalidFeatureSharpness:
        return this.$t('componentsfacetrackerFaceDirectionModal.CautionMessageHtmls.CVInvalidFeatureSharpness') as {
          [key: number]: unknown;
        } as CautionMessage[];

      case MessageTypeErrorFaceAction.CVInvalidFeatureHighlight:
        return this.$t('componentsfacetrackerFaceDirectionModal.CautionMessageHtmls.CVInvalidFeatureHighlight') as {
          [key: number]: unknown;
        } as CautionMessage[];

      case MessageTypeErrorFaceAction.CVInvalidFeatureSunglass:
        return this.$t('componentsfacetrackerFaceDirectionModal.CautionMessageHtmls.CVInvalidFeatureSunglass') as {
          [key: number]: unknown;
        } as CautionMessage[];

      case MessageTypeErrorFaceAction.CVInvalidFeatureStraight:
        return this.$t('componentsfacetrackerFaceDirectionModal.CautionMessageHtmls.CVInvalidFeatureStraight') as {
          [key: number]: unknown;
        } as CautionMessage[];

      case MessageTypeErrorFaceAction.Timeout:
        return [];

      case MessageTypeErrorFaceAction.None:
        return [];

      case MessageTypeErrorFaceAction.Unknown:
      default:
        return [];
    }
  }
}
